var React = require('react');

function UserFull24x24 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=24x24, Invert=off, Active=on","fill":"currentColor","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10"},[React.createElement("path",{"id":"Vector","d":"M12 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9z","key":0}),React.createElement("path",{"id":"Vector_2","d":"M21.5 20a3 3 0 01-3 3h-13a3 3 0 01-3-3 9.5 9.5 0 1119 0z","key":1})]));
}

UserFull24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = UserFull24x24;

UserFull24x24.default = UserFull24x24;
